export default __webpack_public_path__ + "static/media/art-2-healthy.73f495d4.jpg";